import React from "react";
import "./stylesheet/selectTicketStyle.css";
import { Exercise } from "../../../models/Exercise";
import AssortBasketSelector from "../../../../features/Selectors/AssortBasketSelector";
import { TicketAccess } from "../../../models/TicketAccess";
import { BasketItem } from "../../../models/BasketItem";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { useTranslation } from "react-i18next";

interface IProps {
  exercise: Exercise;
  basket: BasketItem[];
  addAssortToBasket: Function;
}

const SelectTickets: React.FC<IProps> = ({ exercise, basket, addAssortToBasket }: IProps) => {
  const isDesktop = useDesktopSize();
  const { t } = useTranslation();
  return (
    <div className={"tickets-wrapper"}>
      {basket.map((item: BasketItem, index: number) => (
        <React.Fragment key={index}>
          {item.ticketAccess.map((value: TicketAccess) => (
            <div className={`basket-ticket ${!isDesktop ? "mobile" : ""}`}>
              <div>
                <p>
                  {t("rzad")}: {value.rowName}, {t("miejsce")}: {value.seatName}
                </p>
                <AssortBasketSelector
                  exercise={exercise}
                  onChangeSelect={(assortIds: string) => addAssortToBasket(assortIds, item)}
                  basketItem={item}
                />
              </div>
            </div>
          ))}
        </React.Fragment>
      ))}

      {/*<div key={value.seatIds} className={"ticket-button"}>*/}
      {/*  <div className={"ticket-btn-info"}>*/}
      {/*    <p>*/}
      {/*      Rząd: {value.rowName}, miejsce: {value.seatName}*/}
      {/*    </p>*/}
      {/*  </div>*/}
      {/*  <AssortBasketSelector*/}
      {/*      exercise={exercise}*/}
      {/*      onChangeSelect={(assortIds: string) => addToBasket(assortIds, item)}*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  );
};

export default SelectTickets;
